export default defineNuxtPlugin(async () => {
    const draftModeCookie = useCookie(COOKIE_NAME_DRAFT_MODE);

    // Otherwise, area.ts will crash on initialization
    await initCountryLanguages(draftModeCookie.value || false);
});
